import { contentLocaleSchema } from '@today/models'

/** True when the tag is a content locale (`^[a-z]{2,3}-[A-Z]{2}$`, e.g. `es-ES`). */
export const isContentLocale = (tag: string): boolean => contentLocaleSchema.safeParse(tag).success

/**
 * Language options of a content picker (TO-420 content-admin-ui REQ-013): the
 * tenant's enabled locales that are content locales, in stored order, then the
 * type's required locales not already listed. "Other" is added by the view.
 */
export const localeOptions = (enabled: readonly string[], typeRequired: readonly string[]): string[] => {
	const options: string[] = []
	for (const tag of [...enabled, ...typeRequired]) {
		if (isContentLocale(tag) && !options.includes(tag)) options.push(tag)
	}
	return options
}
